@if (isLoadingData()) {
  <div class="reviews reviews--skeleton" [attr.data-style]="design()">
    <ush-movie-detail-skeleton width="9rem" height="1.5rem" />
    <div class="reviews--skeleton-items">
      @for (item of design() === 'carousel' ? [1] : [1, 2]; track item) {
        <div class="reviews--skeleton-item">
          <ush-movie-detail-skeleton width="100%" height="1.25rem" />
          <ush-movie-detail-skeleton width="88%" height="1.25rem" />
          <div class="reviews--skeleton-rating">
            <ush-movie-rating [rating]="3" [size]="1" [isLoadingData]="true" />
          </div>
          <ush-movie-detail-skeleton width="7rem" height="0.9rem" />
        </div>
      }
    </div>
  </div>
} @else if (pressReviews()) {
  <div class="reviews" [attr.data-style]="design()">
    @switch (design()) {
      @case ('standard') {
        <div
          class="reviews-header header-msg title"
          i18n-attr="@@public.commons.reviews"
          data-translate="public.commons.reviews"
          i18n="@@public.commons.reviews"
        >
          Reviews
        </div>
        <div class="reviews-container movie-detail-section">
          @for (review of pressReviews(); track review.id) {
            <a
              [href]="review.url ? review.url : ''"
              class="review-item {{ review.url ? 'pointer' : '' }}"
              target="_blank"
            >
              @if (review.rating) {
                <div class="review-rating">
                  @for (star of numToArray(review.rating); track star) {
                    <i class="pi pi-star" style="font-size: 1rem"></i>
                  }
                </div>
              }
              @if (review.quote) {
                <div class="review-item-quote subtitle">{{ review.quote }}</div>
              }
              @if (review.press?.name) {
                <div class="review-item-source" [innerHTML]="review.press.name | safe: 'html'"></div>
              }
            </a>
          }
        </div>
      }
      @case ('carousel') {
        <h1
          class="reviews-header header-msg title"
          i18n-attr="@@public.commons.reviews"
          data-translate="public.commons.reviews"
          i18n="@@public.commons.reviews"
        >
          Reviews
        </h1>
        <div id="reviewsCarousel" class="reviews-carousel page-content">
          <swiper-container ushSwiperElement [config]="reviewsSwiperConfig" init="false">
            @for (review of pressReviews(); track review.id) {
              <swiper-slide>
                <div class="review-item">
                  @if (review.quote) {
                    <div class="review-item-quote">{{ review.quote }}</div>
                  }
                  <ush-movie-rating [rating]="review.rating" [size]="3" [isLoadingData]="isLoadingData()" />
                  <div class="review-item-source">{{ review.press.name }}</div>
                </div>
              </swiper-slide>
            }
          </swiper-container>
        </div>
      }
    }
  </div>
}
